import styled from 'styled-components'

export const InfoReschedule = styled.div`
  display: flex;
  justify-content: flex-start;
  column-gap: 8px;
  margin-bottom: 8px;

  :last-child {
    margin-bottom: 0;
  }
`
export const Value = styled.h3`
  color: ${(props) => props.theme.colors.feedback.success.A500};
`
